<template>
  <div class="green lighten-4">
    <v-container style="max-width: 1800px">
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/digitalmeter/overall`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >{{ $t('meter.overall_electricity_usage') }}</v-btn
      >
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/digitalmeter/log`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >{{ $t('historical_data') }}</v-btn
      >
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    type: String
  }
};
</script>

<style lang="scss" scoped>
.tool-bar{
  background-color: rgb(233,249,238);
  border: 1px solid rgb(221,242,228);
}
</style>
